import { useState, Dispatch, useEffect, memo } from 'react';
import { Props } from './types';
import { Container } from './style';
import { Modal, Button, Badge, Tooltip } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { loadRequest as loadOcorrenciaRequest } from '../../../../store/ducks/ocorrencia/actions';
import { loadRequest } from '../../../../store/ducks/atendimentos/actions';
import { clearMenssage } from '../../../../store/ducks/sendMenssages/actions';
import {
  loadNotifications,
  loadMessageReadRequest,
} from '../../../../store/ducks/notifications/actions';
import { loadRequest as loadRequestProgressBar } from '../../../../store/ducks/progressBarSLA/actions';
import LeftContainer from './LeftContainer';
import RigthContainer from './RigthContainer';

const ModalConversacao: React.FC<Props> = ({ propriedades }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const naoLidos: number = propriedades ? propriedades.naoLidos : 0;
  const filter = useSelector((state: ApplicationState) => state.Atendimentos.filter);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const paginations = useSelector((state: ApplicationState) => state.Atendimentos.pagination);
  const [visibleModalConversacao, setVisibleModalConversacao] = useState(false);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);

  useEffect(() => {
    if (visibleModalConversacao === true) dispatch(loadRequestProgressBar(propriedades.protocolo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleModalConversacao]);

  useEffect(() => {
    if (visibleModalConversacao === true) dispatch(loadOcorrenciaRequest(propriedades.protocolo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleModalConversacao]);

  useEffect(() => {
    if (visibleModalConversacao === true) dispatch(loadMessageReadRequest(propriedades.protocolo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleModalConversacao, perfil]);

  useEffect(() => {
    if (!visibleModalConversacao)
      dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, paginations));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleModalConversacao]);

  return (
    <>
      <Tooltip title={naoLidos}>
        <Badge
          count={naoLidos}
          color={naoLidos <= 0 ? 'transparent' : '#F5222D'}
          style={{ borderColor: 'transparent' }}
        >
          <Button
            onClick={() => {
              setVisibleModalConversacao(true);
            }}
            type="ghost"
            icon={<MailOutlined />}
          />
        </Badge>
      </Tooltip>

      <Modal
        centered
        visible={visibleModalConversacao}
        width={1600}
        onCancel={() => {
          setVisibleModalConversacao(false);
          dispatch(loadNotifications(inscricaoAtiva));
          dispatch(clearMenssage());
        }}
        footer={[]}
      >
        <Container>
          <LeftContainer propriedades={propriedades} />
          <RigthContainer />
        </Container>
      </Modal>
    </>
  );
};

export default memo(ModalConversacao);
